import React, { useState, useEffect } from "react"
import "./cards-description-product.scss"
import flujo from "../../../assets/images/icons_card/Flujo moderado.svg"
import tritech from "../../../assets/images/icons_card/Tritech.webp"
import lavar from "../../../assets/images/icons_card/Lavar panty.svg"
import panty from "../../../assets/images/icons_card/Panty.svg"
import horas from "../../../assets/images/icons_card/horas.png"
import libreLatex from "../../../assets/images/icons_card/libre latex.png"
import amigable from "../../../assets/images/icons_card/amigable ambiente.png"
import silicona from "../../../assets/images/icons_card/silicona grado medico.png"
import sizeGuide from "../../../assets/images/icons_card/performance/v-cup-size-guide.webp"
import MenosPlastico from "../../../assets/images/Toalla-reutilizable/performance/Menos plastico.webp"
import Materiales from "../../../assets/images/Toalla-reutilizable/performance/Materiales respirables.webp"
import UsaLava from "../../../assets/images/Toalla-reutilizable/performance/Usa lava.webp"
import TitleTab from "../../../shared/components/atoms/title-tab/title-tab"

const CardsDescriptionProduct = ({ haveShopSecret,flujoType,code } ) => {
  const isCup = code.includes("CUP")
  const isToallaReu = code.includes("TREU")

  const cards = isCup ?
    [
      {
        id: 1,
        img: horas,
        description: (
          <p>
            Hasta 12 horas de comodidad y protección.
          </p>

        ),
      },
      {
        id: 2,
        img: libreLatex,
        description: (
          <p>
            Libre de látex y BPA.
          </p>
        ),
      },
      {
        id: 3,
        img: amigable,
        description: (
          <p>
            Amigable con el medio ambiente.
          </p>
        ),
      },
      {
        id: 4,
        img: silicona,
        description: (
          <p>
            Silicona grado médico.
          </p>
        ),
      },
    ] : isToallaReu ?
      [
        {
          id: 1,
          img: MenosPlastico,
          description: (
            <>
              <p>85% menos plástico*,</p>
              <p>70% menos desperdicio*</p>
            </>
          ),
        },
        {
          id: 2,
          img: Materiales,
          description: (
            <p>
              Hecha con 95% de materiales
              respirables a base de plantas que
              permiten el paso del aire, pero
              nunca la humedad
            </p>
          ),
        },
        {
          id: 3,
          img: UsaLava,
          description: (
            <p>
              USA, LAVA, REUSA: Puedes
              usar y lavar tu Toalla
              Reutilizable más de 25 veces
            </p>
          ),
        },
      ]
      :
      [
        {
          id: 1,
          img: flujo,
          description: (
            <p>
              Si tienes un flujo <b>regular o abundante</b> tendrás la protección adecuada. Su absorción es de 8-12 horas
            </p>
          ),
        },
        {
          id: 2,
          img: tritech,
          description: (
            <p>
              Con su tecnología Tritech estarás <b>seca, cómoda y libre</b> de
              posibles olores, para sentirte segura y confiada.
            </p>
          ),
        },
        {
          id: 3,
          img: lavar,
          description: (
            <p>
              {process.env.LOCALE === "es-CL" ? (
                <>
                  Puedes lavar tu Calzón Reutilizable a <b> mano con agua fría </b>y
                  luego lavarlo en la lavadora, así se removerán todos los fluidos.
                </>
              ) : (
                <>
                  Puedes lavar tú{" "}
                  {process.env.LOCALE === "es-BO" ? "ropa interior" : "Panty"} a{" "}
                  <b> mano con agua fría </b>y luego lavas en la lavadora, así se
                  removerán todos los fluidos.
                </>
              )}
            </p>
          ),
        },
        {
          id: 4,
          img: panty,
          description: (
            <p>
              {process.env.LOCALE === "es-CL" ? (
                <>
                  ¡Usa, lava y reutiliza! Tu Calzón Íntimawear de Nosotras es más{" "}
                  <b> sostenible con el medio ambiente.</b>
                </>
              ) : (
                <>
                  ¡Usa, lava y reusa! Tu {process.env.LOCALE !== "es-BO" && "Panty"}{" "}
                  intimawear de Nosotras es más{" "}
                  <b> sostenible con el medio ambiente.</b>
                </>
              )}
            </p>
          ),
        },
      ]

  return (
      <section className="f-card-product-section">
      {isToallaReu ?
        <TitleTab className={"f-TitleTab f-TitleTab-pink"}
          title="Conoce nuestras Toallas" /> : null
      }
      {isCup ?
        <TitleTab className={"f-TitleTab f-TitleTab-pink"}
          title="Atributos y beneficios" /> : null
      }
      <div className="f-card-container-scroll">
        <div className="f-card-product-card-container">
          {cards.map(card => (
            <div key={card.id} className="f-card-product-card">
              <div className="f-card-product-card__img">
                <img src={card.img} alt={card.id} />
              </div>
              <div className="f-card-product-card__description">
                {card.description}
              </div>
            </div>
          ))}
        </div>
      </div>
      { isToallaReu ?
      <div className="f-TitleTab-container">
        <p className="f-TitleTab__black">***Comparado con el uso de 50 toallas femeninas desechables durante el mismo período.</p>
      </div>
      :
      haveShopSecret && (
        <div className="f-card-product-title">
          {(isCup && process.env.LOCALE !== "es-CL" ) &&
          <p className="f-card-product-link">
            ¿Quieres conocer más?{" "}
            {process.env.LOCALE !== "es-CL" && (
              <a
                href={
                  process.env.LOCALE === "es-EC"
                    ? "https://www.tiendanosotras.com.ec/"
                    : "https://www.tiendanosotras.com/"
                }
                target="_blank"
              >
                Ingresa a nuestra tienda virtual
              </a>
            )}
          </p>}
        </div>
      )}
      {isCup ?
      <section className="f-card-product-size">
        <TitleTab className={"f-TitleTab f-TitleTab-pink"}
          title="Escoge tu copa ideal" /> 
          <p  className="f-card-product-size-text">Para todas las mujeres. Elige la Nosotras® V-Cup ideal para ti.</p>
        <img className="f-card-product-size-img" src={sizeGuide} alt="Guia de tallas v-cup" loading="lazy" />
      </section>: null
      }
      {isToallaReu && (
        <div className="f-card-product-break"></div>
      )}
    </section>
  )
}

export default CardsDescriptionProduct
